/* Nature's Sanctuary (Circle of the Land 14): the area and what it gives. CommonJS, so the server's sync paths can read it. */
const SANCTUARY_DEFINITION_ID = 'druid:land:natures-sanctuary:area';
const SANCTUARY_AREA = Object.freeze({ shape: 'cube', sizeFeet: 15 });
const SANCTUARY_RANGE_FEET = 120;
const SANCTUARY_MOVE_FEET = 60;
const SANCTUARY_ROUNDS = 10;

const sanctuaries = (combat) => (combat?.activeEffects || []).filter((effect) => effect?.definitionId === SANCTUARY_DEFINITION_ID);
const isInSanctuary = (effect, id) => (effect?.zone?.inside || []).includes(String(id));
/** Half Cover for the Druid and allies in the Cube. */
const sanctuaryCover = (combat, id) => sanctuaries(combat).some((effect) => isInSanctuary(effect, id));
/** Allies in the Cube gain the current Resistance of Nature's Ward. */
const sanctuaryResists = (combat, id, type) => sanctuaries(combat).some((effect) => isInSanctuary(effect, id) && effect.zone.resistance === type);
/** The Cube's `inside` list once a creature has moved. An enemy isn't listed. */
const sanctuaryInsideAfter = (effect, id, inside, allied) => {
  const others = (effect.zone.inside || []).filter((entry) => entry !== String(id));
  return inside && allied ? others.concat(String(id)) : others;
};

module.exports = { SANCTUARY_DEFINITION_ID, SANCTUARY_AREA, SANCTUARY_RANGE_FEET, SANCTUARY_MOVE_FEET, SANCTUARY_ROUNDS, sanctuaryCover, sanctuaryResists, sanctuaryInsideAfter };
